/**
 * Os avisos do envelope, na tela.
 *
 * Não é decoração: é onde mora a diferença entre um número e um número
 * confiável. "A quantidade é contagem de linhas colapsadas", "112 produtos têm
 * gêmeo IF e estão somados", "5 de 6 linhas do fechamento estão ilegíveis" — o
 * dono precisa ler isso ANTES de tomar decisão com o número ao lado.
 *
 * Por isso os avisos ficam recolhidos mas com a contagem visível, e nunca
 * escondidos atrás de um ícone silencioso.
 */
import React, { useState } from "react";
import * as AlfredoStyles from "../../styles/components/reports/RelatorioComum";
import type { AvisoDoRelatorio } from "../../comum/relatorios/tipos";

interface Props {
  avisos?: AvisoDoRelatorio[];
  /** Aviso fixo da visão escolhida (§7.5), que não vem do servidor. */
  avisoDaVisao?: string;
  /** Começa aberto quando a tela depende dos avisos para ser entendida. */
  comecarAberto?: boolean;
}

const AvisosDoRelatorio: React.FC<Props> = ({
  avisos,
  avisoDaVisao,
  comecarAberto,
}) => {
  const [aberto, setAberto] = useState(Boolean(comecarAberto));
  const lista = avisos ?? [];

  if (lista.length === 0 && !avisoDaVisao) return null;

  return (
    <AlfredoStyles.Bloco>
      <AlfredoStyles.Icone>info</AlfredoStyles.Icone>

      {avisoDaVisao && (
        <AlfredoStyles.Texto style={{ width: "100%" }}>
          <AlfredoStyles.Forte>Sobre esta visão: </AlfredoStyles.Forte>
          {avisoDaVisao}
        </AlfredoStyles.Texto>
      )}

      {lista.length > 0 && (
        <>
          <AlfredoStyles.Texto>
            {lista.length} observação(ões) sobre como estes números foram
            apurados.
          </AlfredoStyles.Texto>
          <AlfredoStyles.BotaoDeDetalhe
            type="button"
            onClick={() => setAberto((antes) => !antes)}
          >
            {aberto ? "esconder" : "ler"}
          </AlfredoStyles.BotaoDeDetalhe>
        </>
      )}

      {aberto && (
        <AlfredoStyles.ListaDeAvisos>
          {lista.map((aviso) => (
            <AlfredoStyles.ItemDeAviso key={aviso.codigo}>
              <AlfredoStyles.CodigoDoAviso>
                {aviso.codigo}
              </AlfredoStyles.CodigoDoAviso>
              <AlfredoStyles.Texto>
                {aviso.texto}
                {aviso.colunas && aviso.colunas.length > 0 && (
                  <>
                    {" "}
                    <em>(afeta: {aviso.colunas.join(", ")})</em>
                  </>
                )}
              </AlfredoStyles.Texto>
            </AlfredoStyles.ItemDeAviso>
          ))}
        </AlfredoStyles.ListaDeAvisos>
      )}
    </AlfredoStyles.Bloco>
  );
};

export default AvisosDoRelatorio;
